import classNames from 'classnames';
import { FocusTrap } from 'focus-trap-react';
import * as React from 'react';
import navButtonStyles from '../Shared/Styles/NavButton.module.css';
import { Button } from '~/Partials/Button/Button';
import type { MenuContentProps } from '~/Partials/Nav/Components/MenuContent/MenuContent';
import { MenuContent } from '~/Partials/Nav/Components/MenuContent/MenuContent';
import type { NavButtonProps } from '~/Partials/Nav/Components/NavButtons/NavButtons';
import { NavItem } from '~/Partials/Nav/NavItem';
import { SvgIcon } from '~/Partials/SvgIcon/SvgIcon';
import styles from './MenuContentButton.module.css';

export interface MenuContentButtonProps extends NavButtonProps {
    isFirstPaint: boolean;
    isOpened: (navItem: NavItem) => boolean;
    toggleItem: (navItem: NavItem) => void;
    menuTranslation: string;
    menuContentProps: Omit<MenuContentProps, 'isOpened'>;
}

export const MenuContentButton: React.FC<React.PropsWithChildren<MenuContentButtonProps>> = props => {
    const { isFirstPaint, isOpened, toggleItem, menuTranslation, menuContentProps, variant } = props;

    return (
        <div
            className={classNames(
                !isFirstPaint && (isOpened(NavItem.Menu) ? styles['Variant--opened'] : styles['Variant--closed'])
            )}
        >
            <FocusTrap active={isOpened(NavItem.Menu)} focusTrapOptions={{ allowOutsideClick: true }}>
                <div>
                    <Button
                        onClick={() => toggleItem(NavItem.Menu)}
                        className={classNames(
                            navButtonStyles.ButtonIcon,
                            variant && navButtonStyles[`Variant--${variant}`]
                        )}
                        aria-haspopup="true"
                        aria-expanded={isOpened(NavItem.Menu)}
                    >
                        <span className="visuallyHidden">{menuTranslation}</span>
                        {isOpened(NavItem.Menu) ? <SvgIcon iconName="close" /> : <SvgIcon iconName="menu" />}
                    </Button>
                    {menuContentProps.sections && menuContentProps.sections.length > 0 && (
                        <MenuContent {...menuContentProps} isOpened={isOpened(NavItem.Menu)} />
                    )}
                </div>
            </FocusTrap>
        </div>
    );
};
